import axios from 'axios';
import { getCookie } from '@services/localStorage';

export const Axios = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API : 'https://api.elevargestao.com.br',
  headers: {
    Authorization: `Bearer ${getCookie('token')}`,
  },
});

// Add a request interceptor
Axios.interceptors.request.use(
  function (config) {
    //const contextoid = Cookies.get('contextoid');
    //if(!contextoid)
    // Do something before request is sent
    const token = getCookie('token');
    config.headers = {
      ...config.headers,
      Authorization: token ? `Bearer ${token}` : '',
    };
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
Axios.interceptors.response.use(
  function (response) {
    //console.log(response);
    return response;
  },
  function (error) {
    if (error.message === 'Request failed with status code 401' && error.config.url !== '/api/v2/Usuarios/Check')
      window.location.href = '/Login?ReturnURL=' + error.config.url;
    return Promise.reject(error);
  }
);

export default axios;
